/** 专区合同新增/编辑 — 物料表单行（与详情物料表字段对齐，不含完成量等只读字段） */
export interface ZoneContractMaterialFormRow {
    /** 列表 key，删除行时稳定渲染 */
    id: string;
    materialName: string;
    /** 编辑时进入页面的原始单价，用于判断本次是否发生单价调整 */
    originalUnitPrice?: number;
    unitPrice: number | undefined;
    /** 编辑合同调整单价后的生效时间；新增合同通常不传 */
    priceEffectiveTime?: string;
    settlementRate: number | undefined;
    contractQty: number | undefined;
    /** 预约单计划量总和下限（来自合同 VO），编辑时用于校验合同量 */
    minContractQtyFromBookings?: number;
}

export interface ZoneContractMaterialOption {
    label: string;
    value: string;
}

/** 默认物料名称选项，可通过组件 props 覆盖 */
export const DEFAULT_ZONE_CONTRACT_MATERIAL_OPTIONS: ZoneContractMaterialOption[] = [
    { label: "机制砂0-5mm", value: "机制砂0-5mm" },
    { label: "瓜米5-16mm", value: "瓜米5-16mm" },
    { label: "石子16-25mm", value: "石子16-25mm" }
];

let _rowId = 0;
function nextRowId(): string {
    _rowId += 1;
    return `zcm-${Date.now()}-${_rowId}`;
}

export function createEmptyZoneContractMaterialRow(): ZoneContractMaterialFormRow {
    return {
        id: nextRowId(),
        materialName: "",
        unitPrice: undefined,
        settlementRate: undefined,
        contractQty: undefined
    };
}

/** 单价：整数，(0, 10_000] */
export const ZONE_CONTRACT_UNIT_PRICE_MAX = 10_000;

/** 合同量：整数，(0, 1_0000_0000] */
export const ZONE_CONTRACT_QTY_MAX = 100_000_000;
